import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { UiActionExpanderModule } from '@components/ui-action-expander';
import { UiValueTypeModule } from '@components/ui-value-type/ui-value-type.module';
import { SharedModule } from '@modules/shared.module';
import { UiGridResetModule } from '@pages/generics/grid/grid-reset';
import { MachinesPageComponent } from '@pages/machines/machines.page';
import { UiGridModule } from '@uipath/angular/components/ui-grid';
import { UiSuggestModule } from '@uipath/angular/components/ui-suggest';
import { UiAutofocusModule } from '@uipath/angular/directives/ui-autofocus';
import { UiClipboardModule } from '@uipath/angular/directives/ui-clipboard';
import { UiNgLetModule } from '@uipath/angular/directives/ui-ng-let';
import { UiSpinnerButtonModule } from '@uipath/angular/directives/ui-spinner-button';

import { UiMachineRobotVersionsDisplayComponent } from './components';
import { MachineRobotVersionsGridComponent } from './grids';
import {
    MachineModalComponent,
    MachineRobotVersionsModalComponent,
} from './modals';

const MODALS = [
    MachineModalComponent,
    MachineRobotVersionsModalComponent,
];

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        UiSuggestModule,
        UiGridModule,
        UiGridResetModule,
        UiValueTypeModule,
        MatMenuModule,
        UiActionExpanderModule,
        UiNgLetModule,
        UiAutofocusModule,
        UiClipboardModule,
        UiSpinnerButtonModule,
    ],
    declarations: [
        MachinesPageComponent,
        MachineRobotVersionsGridComponent,
        UiMachineRobotVersionsDisplayComponent,
        ...MODALS,
    ],
    exports: [
        MachinesPageComponent,
    ],
    entryComponents: [
        ...MODALS,
    ],
})
export class MachineModule { }
